module.exports = __webpack_public_path__ + "components/flag/static/square/un-eaca42d32d0faa82248b456e6eafb614.svg";